import React from "react";
import { Reveal, SectionLabel } from "./motion";
import { useLang } from "@/LanguageContext";
import { IMAGES } from "@/content";

const HUB_IMG = [IMAGES.brussels, IMAGES.turin, IMAGES.saopaulo];

export default function Group() {
  const { t } = useLang();
  return (
    <section id="group" data-testid="group-section" className="relative py-24 lg:py-36 bg-navy">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="max-w-3xl">
          <Reveal><SectionLabel>{t.group.eyebrow}</SectionLabel></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-white mt-6 tracking-[-0.01em]">{t.group.title}</h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-white/60 leading-relaxed mt-6">{t.group.lead}</p>
          </Reveal>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {t.group.hubs.map((hub, i) => {
            const live = i < 2;
            return (
              <Reveal key={hub.city} delay={i * 0.1} y={50}>
                <div className="group border border-white/10 rounded-sm overflow-hidden bg-surface/40 hover:border-gold/40 transition-colors duration-500">
                  <div className="img-zoom relative aspect-[16/10]">
                    <img src={HUB_IMG[i]} alt={hub.city} className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/30 to-transparent" />
                    <span className={`absolute top-4 left-4 inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] px-3 py-1.5 rounded-full ${live ? "bg-gold text-navy" : "bg-white/10 text-white/80 border border-white/20"}`}>
                      <span className={`h-1.5 w-1.5 rounded-full ${live ? "bg-navy" : "bg-white/60"}`} />
                      {hub.status}
                    </span>
                  </div>
                  <div className="p-8">
                    <div className="flex items-baseline gap-3">
                      <h3 className="font-serif text-2xl text-white">{hub.city}</h3>
                      <span className="text-xs uppercase tracking-[0.2em] text-gold/70">{hub.country}</span>
                    </div>
                    <p className="text-white/60 leading-relaxed mt-4">{hub.body}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
